import { GetterTree } from 'vuex';
import { IModalState, MODAL_GETTERS } from './modal-types.store';

export const getters: GetterTree<IModalState, any> = {
    [MODAL_GETTERS.GET_STATE_MODAL]: (state) => { return state.config; }
}